module.exports = __webpack_public_path__ + "img/circle.fe230e66.svg";